import { Path, Rect } from "react-native-svg";

import { type IconProps, LineIcon } from "./LineIcon";

export function MailIcon(props: IconProps) {
  return (
    <LineIcon {...props}>
      <Rect x="3" y="5" width="18" height="14" rx="2" />
      <Path d="M3.5 6.5l8.5 6.5 8.5-6.5" />
    </LineIcon>
  );
}
